import styled from 'styled-components'

import { DIVIDER, MUTED_TEXT, TEXT, VALUE_TEXT } from '../../../colors'

export const StyledMessageList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const StyledMessageItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;

  & + & {
    border-top: 1px solid ${DIVIDER};
  }
`

export const StyledMessageHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;

  h4 {
    margin: 0;
    color: ${TEXT};
    font-size: 15px;
    font-weight: 500;
  }

  .ant-tag {
    margin-inline-end: 0;
  }
`

export const StyledMessageBody = styled.div`
  color: ${VALUE_TEXT};
  font-size: 14px;
  overflow-wrap: anywhere;
`

export const StyledMessageSection = styled.div`
  & + & {
    margin-top: 16px;
  }
`

export const StyledMessageSubheading = styled.h5`
  margin: 0 0 4px;
  color: ${MUTED_TEXT};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`
